const styles = {
  footer: {
    textAlign: 'center',
    position: 'fixed',
    bottom: 0,
    width: '100%'
  }
};

export default styles;



// WEBPACK FOOTER //
// ./src/components/styles/Footer.js